import type { CaseStudy } from "../CaseStudy.js";

export function getReferencePath({ urlSlug }: Pick<CaseStudy, "urlSlug">): string {
	return urlSlug;
}
